const styleEnglishLocale = (str) => str.replace(/[–](?=\d)|\d(?=[–])/gi, '$& ');

export { styleEnglishLocale };
